import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminBoxSaleMissingItemPickStrategy } from '../enums/admin-box-sale-missing-item-pick-strategy';

@Injectable({
  providedIn: 'root',
})
export class AdminBoxSaleMissingItemPickStrategyProviderService {
  private readonly entries = new Map<AdminBoxSaleMissingItemPickStrategy, string>([
    [AdminBoxSaleMissingItemPickStrategy.FirstAvailable, 'Pierwszy dostępny'],
    [AdminBoxSaleMissingItemPickStrategy.LastAvailable, 'Ostatni dostępny'],
    [AdminBoxSaleMissingItemPickStrategy.MostAvailable, 'Największa dostępność'],
    [AdminBoxSaleMissingItemPickStrategy.LeastAvailable, 'Najmniejsza dostępność'],
    [AdminBoxSaleMissingItemPickStrategy.HighestRemainingRatio, 'Najwyższy stosunek pozostałego zapasu'],
    [AdminBoxSaleMissingItemPickStrategy.LowestRemainingRatio, 'Najniższy  stosunek pozostałego zapasu'],
    [AdminBoxSaleMissingItemPickStrategy.Random, 'Losowy dostępny'],
    [AdminBoxSaleMissingItemPickStrategy.Custom, 'Niestandardowa'],
  ]);

  public labelFor(strategy: AdminBoxSaleMissingItemPickStrategy): Observable<string> {
    const entry = this.entries.get(strategy);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${strategy}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AdminBoxSaleMissingItemPickStrategy>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([strategy, label]) => new SelectItem(label, strategy),
      ),
    );
  }
}
